/**
 * Core analytics module — wraps PostHog so analytics errors never break the app.
 *
 * How to add analytics to a new page/feature:
 *
 *   1. Create `YourPage/analytics/events.ts`
 *      — define a `YOUR_PAGE_EVENTS` const object with all event name strings.
 *
 *   2. Create `YourPage/analytics/types.ts`
 *      — define a TypeScript type for each event that carries properties.
 *
 *   3. Create `YourPage/analytics/index.ts`
 *      — import { trackEvent } from 'analytics'
 *      — export one typed function per tracked action.
 *
 * See src/_clean-code/pages/OperatorPlanningPage/analytics/ for a reference
 * implementation that covers: page view, time-on-page, tab switching, button
 * clicks, modal funnels, and success/error rates.
 */
import posthog from 'posthog-js';

import { Logger } from '_clean-code/utils/logger';

export function trackEvent(
  eventName: string,
  properties?: Record<string, unknown>
): void {
  try {
    posthog.capture(eventName, properties);
  } catch (error) {
    Logger.error(`Failed to track event ${eventName}:`, error);
  }
}
